// マッチ操作のボタン（プランナー詳細・オファー・メッセージ）で同じ文言を使う。
// 確認モーダル（MatchConfirmModal）の見出し「…話を聞いてみますか？」も同じ語を直書きしているので、変えるときは合わせて直す。
export const PLANNER_MATCH_CTA_LABEL = "話を聞いてみる";
